import { useModalState } from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme/src/lib/theme";
import { isDefined } from "@clipboard-health/util-ts";
import { ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useCurrentDate } from "@src/appV2/lib/utils/useCurrentDate";
import { SHIFT_DETAILS_UPDATE_ETA_FULL_PATH } from "@src/appV2/redesign/WorkerShifts/path";
import { CancelShiftBottomSheet } from "@src/appV2/redesign/WorkerShifts/ShiftDetails/components/CancelShiftBottomSheet";
import { useCancelShiftBottomSheetData } from "@src/appV2/redesign/WorkerShifts/ShiftDetails/hooks/useCancelShiftBottomSheetData";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { generatePath, useHistory } from "react-router-dom";

import { UPDATE_ETA_BOTTOM_SHEET_SOURCE } from "./UpdateEta/types";
import { UpdateEtaNudgeBottomSheet } from "./UpdateEtaNudgeBottomSheet";
import { useEtaNudgeData } from "./useEtaNudgeData";

export function UpdateEtaNudgeBottomSheetContainer() {
  const modalState = useModalState("open");
  const history = useHistory();
  const worker = useDefinedWorker();
  const now = useCurrentDate(1000);

  const { shiftEligibleForTrip, trip, shiftStartDate, shouldShowEtaNudgeBottomSheet } =
    useEtaNudgeData();

  const { cancelShiftBottomSheetProps, handleOpenCancelShiftBottomSheet } =
    useCancelShiftBottomSheetData({
      shiftId: shiftEligibleForTrip?._id,
      shiftStartDate,
      currentDate: now,
      clockInStartIso: shiftEligibleForTrip?.clockInOut?.start,
      orientationBlockId: shiftEligibleForTrip?.orientationBlockId,
    });

  useLogEffect(
    APP_V2_USER_EVENTS.UPDATE_ETA_BOTTOM_SHEET_NUDGE_VIEWED,
    {
      workerId: worker.userId,
      shiftId: shiftEligibleForTrip?._id,
      tripId: trip?.id,
    },
    {
      enabled: shouldShowEtaNudgeBottomSheet,
    }
  );

  if (!shouldShowEtaNudgeBottomSheet || !isDefined(shiftEligibleForTrip)) {
    return null;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <UpdateEtaNudgeBottomSheet
        modalState={modalState}
        onUpdateEta={() => {
          modalState.closeModal();
          history.push(
            generatePath(
              `${SHIFT_DETAILS_UPDATE_ETA_FULL_PATH}?source=${UPDATE_ETA_BOTTOM_SHEET_SOURCE.UPDATE_ETA_BOTTOM_SHEET_NUDGE}`,
              {
                shiftId: shiftEligibleForTrip._id,
              }
            )
          );
        }}
        onCancelShift={() => {
          modalState.closeModal();
          handleOpenCancelShiftBottomSheet();
        }}
      />
      {isDefined(cancelShiftBottomSheetProps) ? (
        <CancelShiftBottomSheet {...cancelShiftBottomSheetProps} />
      ) : null}
    </ThemeProvider>
  );
}
